<template>
  <div class="sf-preview" :style="{ background: c('--johku-color-background', '#ffffff'), color: c('--johku-color-text', '#000000') }">
    <div class="sf-preview-navbar" :style="{ background: c('--johku-color-navbar-background', '#ffffff'), color: c('--johku-color-navbar-text', '#000000') }">
      <strong>{{ _('Shop name') }}</strong>
      <span class="sf-preview-cart">
        <i class="fa fa-fw fa-shopping-cart"></i>
        <span class="sf-preview-badge" :style="{ background: c('--johku-color-navbar-cart-count-background', primary), color: c('--johku-color-navbar-cart-count-text', '#ffffff') }">2</span>
      </span>
    </div>
    <div class="sf-preview-breadcrumb" :style="{ background: c('--johku-color-breadcrumb-background', accent), color: c('--johku-color-breadcrumb-text', '#ffffff') }">
      {{ _('Front page') }} / {{ _('Products') }}
    </div>
    <div class="sf-preview-body">
      <div class="sf-preview-card" :style="{ borderColor: c('--johku-color-border', '#dddddd') }">
        <div class="sf-preview-title" :style="{ color: c('--johku-color-text-title', accent) }">{{ _('Product name') }}</div>
        <p>{{ _('A short description of the product.') }}</p>
        <div class="sf-preview-price" :style="{ background: c('--johku-color-orderwrap-background', '#eeeeee'), color: c('--johku-color-orderwrap-text', '#000000') }">
          <span>{{ _('Price') }}</span>
          <strong :style="{ color: c('--johku-color-orderwrap-text-price', primary) }">49,00 €</strong>
        </div>
        <div class="sf-preview-buttons">
          <span class="sf-preview-btn" :style="{ background: c('--johku-color-button-primary-background', primary), color: c('--johku-color-button-primary-text', '#ffffff') }">{{ _('Add to basket') }}</span>
          <span class="sf-preview-btn" :style="{ background: c('--johku-color-success', '#00840f'), color: c('--johku-color-button-text', '#ffffff') }">{{ _('Checkout') }}</span>
        </div>
      </div>
    </div>
    <div class="sf-preview-footer" :style="{ background: c('--johku-color-footer-background', '#000000'), color: c('--johku-color-footer-text', '#ffffff') }">
      {{ _('Contact us') }} · <span :style="{ color: c('--johku-color-footer-link', '#ffffff') }">info@example.com</span>
    </div>
    <div class="sf-preview-footer-bar" :style="{ background: c('--johku-color-footer-bar-background', '#212121'), color: c('--johku-color-footer-bar-text', '#ffffff') }">
      © {{ _('Shop name') }}
    </div>
  </div>
</template>

<script>
import { resolveTokenColor } from '~/lib/storefrontColors'

export default {
  props: {
    tokens: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    primary () {
      return resolveTokenColor(this.tokens, '--johku-color-primary') || '#6a9e29'
    },
    accent () {
      return resolveTokenColor(this.tokens, '--johku-color-secondary') || '#01b5dd'
    }
  },
  methods: {
    c (key, fallback) {
      return resolveTokenColor(this.tokens, key) || fallback
    }
  }
}
</script>

<style scoped>
.sf-preview {
  border: 1px solid #ddd;
  border-radius: 6px;
  overflow: hidden;
  font-size: 12px;
  margin-bottom: 15px;
}
.sf-preview-navbar,
.sf-preview-breadcrumb,
.sf-preview-footer,
.sf-preview-footer-bar {
  padding: 6px 10px;
}
.sf-preview-navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sf-preview-cart {
  position: relative;
}
.sf-preview-badge {
  border-radius: 8px;
  padding: 0 5px;
  font-size: 10px;
  font-weight: bold;
}
.sf-preview-body {
  padding: 10px;
}
.sf-preview-card {
  border: 1px solid;
  border-radius: 6px;
  padding: 10px;
}
.sf-preview-title {
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 4px;
}
.sf-preview-price {
  display: flex;
  justify-content: space-between;
  border-radius: 6px;
  padding: 8px 10px;
  margin-bottom: 8px;
}
.sf-preview-buttons {
  display: flex;
  gap: 6px;
}
.sf-preview-btn {
  border-radius: 6px;
  padding: 5px 10px;
  font-weight: bold;
}
</style>
